<template>
  <transition-group
    class="overlay"
    name="overlay-manager-animation"
    tag="div"
  >
    <OverlayItem
      v-for="item in messages"
      :key="item.id"
      :id="item.id"
      :text="item.text"
      :color="item.color"
      :icon="item.icon"
    />
  </transition-group>
</template>

<script setup>
  import { computed, onMounted, onBeforeUnmount } from 'vue';
  import { useStore } from 'vuex';
  import { callOverlay } from '@/Groups/OverlayManager/public/utils/callOverlay';
  import OverlayItem from '@/Groups/OverlayManager/private/core/OverlayItem/OverlayItem.vue';

  const store = useStore();

  const messages = computed(() =>
    store.getters['OverlayManager/allMessages']
  );

  // --------------------------
  // ТЕСТ: клик по документу
  // --------------------------
  const onDocClick = () => {
    callOverlay({ text: 'Сигнал был изменен', color: 'green', icon: 'pen' });
    callOverlay({ text: 'Не удалось добавить сигнал', color: 'red', icon: 'signal' });
    callOverlay({ text: 'Авторизация не успешна', color: 'red', icon: 'person' });
    callOverlay({ text: 'Успешный запрос', color: 'green', icon: 'wifi' });
    callOverlay({ text: 'Что то успешно было удалено', color: 'green', icon: 'delete' });
    callOverlay({ text: 'Что то было скопировано', color: 'green', icon: 'copy' });
    callOverlay({ text: 'Что то было прикреплено', color: 'green', icon: 'pin' });
    callOverlay({ text: 'Что то было опубликовано', color: 'green', icon: 'alpha' });
    callOverlay({ text: 'Авторизация через телеграм', color: 'green', icon: 'telegram' });
    callOverlay({ text: 'Ошибка с вводом пароля', color: 'green', icon: 'lock' });
    callOverlay({ text: 'Добро пожаловать, Легенда Кэпитала!', color: 'legend', icon: 'crown' });
  };

  onMounted(() => {
    /* document.addEventListener('click', onDocClick); */
  });

  onBeforeUnmount(() => {
    /* document.removeEventListener('click', onDocClick); */
  });
</script>

<style lang="scss" scoped>
  @import "./styles";
</style>